import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { PageInfoService } from './layouts/page-info.service';
import { PageInfo } from './layouts/page-info';
import { AuthenticationService } from './authentication/authentication.service';
import { GoogleAnalyticsService } from './google-analytics/google-analytics.service';

/**
 * The bootstrap (main) component for the application.
 */
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

// #region [ Constructor ]

	constructor(
		private _Router: Router,
		private _PageInfoService: PageInfoService,
		private _AuthenticationService: AuthenticationService,
		private _GoogleAnalyticsService: GoogleAnalyticsService,
		private _Title: Title

	) {
		this._Router.events.subscribe(objEvent => this.OnRoute(objEvent));
		this._PageInfoService.GetPageInfoObserver().subscribe(objInfo => this.OnUpdatePageInfo(objInfo));
	}
	
// #region [ Event Handlers ]

	/**
	 * Component initialization.
	 */
	ngOnInit(): void {
		// Initialize the google analytics service
		this._GoogleAnalyticsService.Initialize();
	}

	/**
	 * Updates the page title for the application, prefixing it with Crown Connect.
	 * 
	 * @param Info The data for the skin elements of the page.
	 */
	private OnUpdatePageInfo(Info: PageInfo): void {
		this._Title.setTitle("Crown Connect - " + Info.PageTitle);
	}

	/**
	 * Checks if the event type is NavigationEnd and posts a GA page view if it is.
	 *
	 * @param Event The event fired by the navigation event.
	 */
	private OnRoute(Event: object): void {
		if (Event instanceof NavigationEnd) {
			this._GoogleAnalyticsService.TrackPageViewEvent(this._PageInfoService.PageTitle, Event.urlAfterRedirects, this._AuthenticationService.UserIdentifier);
		}
	}
}